export default __webpack_public_path__ + "static/media/m-fsk-21.cdf0cd8a.jpg";